import ProductsSlider from "../class/ProductsSlider";

new ProductsSlider('.swiper-products').init();
